const WindowSidebar = ({ className, fill = "#606B80" }) => {
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 18.375H3.5C2.5335 18.375 1.75 17.5915 1.75 16.625V4.375C1.75 3.4085 2.5335 2.625 3.5 2.625H17.5C18.4665 2.625 19.25 3.4085 19.25 4.375V16.625C19.25 17.5915 18.4665 18.375 17.5 18.375ZM8.75 6.125V16.625H17.5V6.125H8.75ZM3.5 6.125V16.625H7V6.125H3.5Z"
        fill={fill}
      />
    </svg>
  );
};

const SupportAccess = ({ className = "", fill = "#606B80" }) => {
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 18.375H3.5C3.01675 18.375 2.625 17.9832 2.625 17.5V3.5C2.625 3.01675 3.01675 2.625 3.5 2.625H17.5C17.9832 2.625 18.375 3.01675 18.375 3.5V17.5C18.375 17.9832 17.9832 18.375 17.5 18.375ZM4.375 4.375V16.625H16.625V4.375H4.375ZM12.25 14.875H9.625V11.375H8.75V9.625H11.375V13.125H12.25V14.875ZM11.375 7.875H9.625V6.125H11.375V7.875Z"
        fill={fill}
      />
    </svg>
  );
};

const NotAllowed = ({ className = "", fill = "#606B80" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={fill}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={className}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
    </svg>
  );
};

const User = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.375 18.375H2.625V17.5C2.62886 14.1189 5.36886 11.3789 8.75 11.375H12.25C15.6311 11.3789 18.3711 14.1189 18.375 17.5V18.375H16.625V17.5C16.6221 15.085 14.665 13.1279 12.25 13.125H8.75C6.33495 13.1279 4.37789 15.085 4.375 17.5V18.375ZM10.5 10.5C8.08375 10.5 6.125 8.54125 6.125 6.125C6.125 3.70875 8.08375 1.75 10.5 1.75C12.9162 1.75 14.875 3.70875 14.875 6.125C14.8721 8.54005 12.915 10.4971 10.5 10.5ZM10.5 3.5C9.05025 3.5 7.875 4.67525 7.875 6.125C7.875 7.57475 9.05025 8.75 10.5 8.75C11.9497 8.75 13.125 7.57475 13.125 6.125C13.125 4.67525 11.9497 3.5 10.5 3.5Z"
      fill={fill}
    />
  </svg>
);

const Users = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      clipPath="url(#a)"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.875 18.375v-1.75a3.5 3.5 0 0 0-3.5-3.5h-7a3.5 3.5 0 0 0-3.5 3.5v1.75M7.875 9.625a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM20.125 18.375v-1.75a3.5 3.5 0 0 0-2.625-3.386M14 2.739a3.5 3.5 0 0 1 0 6.781" />
    </g>
  </svg>
);

const Refresh = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 17.5001V11.3751H9.625L6.81012 14.1926C7.78134 15.1857 9.11091 15.7469 10.5 15.7501C12.722 15.7468 14.7013 14.345 15.442 12.2501H15.4578C15.558 11.9654 15.6338 11.6726 15.6844 11.3751H17.4449C17.0039 14.875 14.0276 17.5 10.5 17.5001H10.4913C8.63517 17.5056 6.85402 16.7683 5.54487 15.4526L3.5 17.5001ZM5.31475 9.62507H3.55425C3.99503 6.12648 6.96937 3.50195 10.4956 3.50004H10.5C12.3564 3.4941 14.138 4.23143 15.4473 5.54757L17.5 3.50004V9.62507H11.375L14.1943 6.80757C13.222 5.81326 11.8906 5.25194 10.5 5.25007C8.27798 5.25335 6.29867 6.65513 5.558 8.75007H5.54225C5.44124 9.03454 5.3654 9.32733 5.31563 9.62507H5.31475Z"
      fill={fill}
    />
  </svg>
);

const Notification = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 19.25C9.5335 19.25 8.75 18.4665 8.75 17.5H12.25C12.25 18.4665 11.4665 19.25 10.5 19.25ZM17.5 16.625H3.5V14.875L5.25 14V9.1875C5.25 6.15825 6.49338 4.19388 8.75 3.6575V1.75H12.25V3.6575C14.5066 4.193 15.75 6.1565 15.75 9.1875V14L17.5 14.875V16.625ZM10.5 5.03125C9.43221 4.9623 8.40244 5.44012 7.76562 6.3C7.22098 7.16149 6.95375 8.16933 7 9.1875V14.875H14V9.1875C14.0462 8.16934 13.779 7.16151 13.2344 6.3C12.5976 5.44012 11.5678 4.9623 10.5 5.03125ZM11.375 13.125H9.625V11.375H7.875V9.625H9.625V7.875H11.375V9.625H13.125V11.375H11.375V13.125Z"
      fill={fill}
    />
  </svg>
);

const Close = ({ className = "", fill = "#F7F7F7", strokeWidth = "1.5" }) => (
  <svg
    className={className}
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.5 1.5L10 10" stroke={fill} strokeWidth={strokeWidth} />
    <path d="M10 1.5L1.5 10" stroke={fill} strokeWidth={strokeWidth} />
  </svg>
);

const Envelope = ({ className = "" }) => (
  <svg
    className={className}
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 0.529297H19C20.1 0.529297 21 1.4293 21 2.5293V14.5293C21 15.6293 20.1 16.5293 19 16.5293H3C1.9 16.5293 1 15.6293 1 14.5293V2.5293C1 1.4293 1.9 0.529297 3 0.529297Z"
      fill="#28265B"
    />
    <path
      d="M21 2.5293L11 9.5293L1 2.5293"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MegaPhone = ({ className = "", fill = "#606B80" }) => {
  return (
    <svg
      className={className}
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.667067 4.15527C0.298668 4.15527 0 4.45394 0 4.82234V10.029C0 10.3974 0.298668 10.6961 0.667067 10.6961C1.03547 10.6961 1.33413 10.3974 1.33413 10.029V4.82234C1.33413 4.45394 1.03547 4.15527 0.667067 4.15527Z"
        fill={fill}
      />
      <path
        d="M14.8025 0.26416H12.0272C11.6588 0.26416 11.3601 0.562829 11.3601 0.931228V1.53381L2.42716 4.18278C2.14397 4.26674 1.94972 4.52699 1.94972 4.82228V10.0265C1.94954 10.0598 1.95275 10.0934 1.95773 10.1272C1.95862 10.1334 1.95951 10.1396 1.96057 10.1457C1.96555 10.1733 1.9716 10.2009 1.98023 10.2283L3.87123 16.2675C3.96053 16.5527 4.22371 16.7354 4.50761 16.7354C4.57352 16.7354 4.64058 16.7255 4.70685 16.7048L7.46059 15.8437C7.62949 15.7909 7.77046 15.6732 7.85247 15.5164C7.93456 15.3597 7.95093 15.1768 7.8981 15.0079L6.961 12.0133L11.36 13.3181V13.9205C11.36 14.2889 11.6587 14.5876 12.0271 14.5876H14.8024C15.1708 14.5876 15.4695 14.2889 15.4695 13.9205V0.931228C15.4696 0.562829 15.1709 0.26416 14.8025 0.26416ZM6.42566 14.7695L4.94512 15.2324L3.62753 11.0245L5.42007 11.5561L6.42566 14.7695ZM6.14398 10.3794C6.14211 10.3789 6.14015 10.3782 6.13828 10.3777L3.28395 9.53106V5.32027L11.3602 2.9254V11.9265L6.14398 10.3794ZM14.1354 13.2536H12.6942V12.8202V2.0318V1.59838H14.1354V13.2536Z"
        fill={fill}
      />
      <path
        d="M20.0086 11.1605L17.1222 9.71702C16.7926 9.55239 16.392 9.68571 16.2272 10.0153C16.0624 10.3449 16.196 10.7455 16.5255 10.9104L19.4119 12.3538C19.5077 12.4017 19.6094 12.4243 19.7098 12.4243C19.9544 12.4243 20.19 12.2892 20.3069 12.0555C20.4716 11.726 20.338 11.3253 20.0086 11.1605Z"
        fill={fill}
      />
      <path
        d="M16.8244 5.20498C16.9246 5.20498 17.0265 5.1823 17.1222 5.13436L20.0086 3.69109C20.3381 3.52628 20.4717 3.12569 20.3069 2.79616C20.1422 2.46662 19.7414 2.33303 19.412 2.49784L16.5255 3.94111C16.196 4.10592 16.0624 4.50652 16.2272 4.83605C16.3441 5.06988 16.5797 5.20498 16.8244 5.20498Z"
        fill={fill}
      />
      <path
        d="M20.3331 6.75879H17.923C17.5546 6.75879 17.2559 7.05746 17.2559 7.42586C17.2559 7.79426 17.5546 8.09292 17.923 8.09292H20.3331C20.7015 8.09292 21.0002 7.79426 21.0002 7.42586C21.0002 7.05737 20.7015 6.75879 20.3331 6.75879Z"
        fill={fill}
      />
    </svg>
  );
};

const Bell = ({ className = "", show_ball = false }) => (
  <svg
    className={className}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8.5293C18 6.938 17.3679 5.41187 16.2426 4.28666C15.1174 3.16144 13.5913 2.5293 12 2.5293C10.4087 2.5293 8.88258 3.16144 7.75736 4.28666C6.63214 5.41187 6 6.938 6 8.5293C6 15.5293 3 17.5293 3 17.5293H21C21 17.5293 18 15.5293 18 8.5293Z"
      fill="#28265B"
    />
    <path
      d="M13.73 21.5293C13.5542 21.8324 13.3018 22.0839 12.9982 22.2588C12.6946 22.4337 12.3504 22.5258 12 22.5258C11.6496 22.5258 11.3054 22.4337 11.0018 22.2588C10.6981 22.0839 10.4458 21.8324 10.27 21.5293"
      stroke="#28265B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {show_ball && (
      <circle cx="17.7015" cy="5.22782" r="3.97196" fill="#EC5627" />
    )}
  </svg>
);

const CustomPlansIcon = ({ className = "", fill = "#606B80" }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9991 9.17009L17.045 8.58676C16.9099 8.11502 16.7241 7.65931 16.4908 7.22759L17.4475 5.43676C17.4834 5.36916 17.4965 5.29179 17.485 5.21613C17.4734 5.14047 17.4378 5.07055 17.3833 5.01676L15.9891 3.61676C15.9354 3.56231 15.8654 3.52667 15.7898 3.51511C15.7141 3.50355 15.6367 3.51669 15.5691 3.55259L13.79 4.50342C13.354 4.25881 12.8923 4.06317 12.4133 3.92009L11.83 1.98926C11.8053 1.9181 11.7587 1.85661 11.6968 1.81363C11.635 1.77065 11.5611 1.7484 11.4858 1.75009H9.51415C9.4384 1.75044 9.36474 1.77496 9.30389 1.82007C9.24303 1.86519 9.19817 1.92854 9.17582 2.00092L8.59248 3.92592C8.10949 4.06824 7.64385 4.26389 7.20415 4.50926L5.45415 3.56426C5.38655 3.52836 5.30918 3.51522 5.23352 3.52677C5.15786 3.53833 5.08795 3.57398 5.03415 3.62842L3.61665 5.01092C3.56221 5.06472 3.52656 5.13464 3.515 5.21029C3.50344 5.28595 3.51659 5.36333 3.55248 5.43092L4.49748 7.18092C4.25252 7.61877 4.05688 8.08244 3.91415 8.56342L1.98332 9.14676C1.91094 9.16911 1.84758 9.21398 1.80247 9.27483C1.75735 9.33568 1.73284 9.40934 1.73248 9.48509V11.4568C1.73284 11.5325 1.75735 11.6062 1.80247 11.667C1.84758 11.7279 1.91094 11.7727 1.98332 11.7951L3.92582 12.3784C4.0701 12.8514 4.26571 13.3072 4.50915 13.7376L3.55248 15.5693C3.51659 15.6369 3.50344 15.7142 3.515 15.7899C3.52656 15.8655 3.56221 15.9355 3.61665 15.9893L5.01082 17.3834C5.06461 17.4379 5.13453 17.4735 5.21019 17.4851C5.28585 17.4966 5.36322 17.4835 5.43082 17.4476L7.23332 16.4851C7.65971 16.7152 8.10949 16.899 8.57498 17.0334L9.15832 18.9993C9.18067 19.0716 9.22553 19.135 9.28639 19.1801C9.34724 19.2252 9.4209 19.2497 9.49665 19.2501H11.4683C11.5441 19.2497 11.6177 19.2252 11.6786 19.1801C11.7394 19.135 11.7843 19.0716 11.8066 18.9993L12.39 17.0276C12.8515 16.8925 13.2973 16.7087 13.72 16.4793L15.5341 17.4476C15.6017 17.4835 15.6791 17.4966 15.7548 17.4851C15.8304 17.4735 15.9004 17.4379 15.9541 17.3834L17.3483 15.9893C17.4028 15.9355 17.4384 15.8655 17.45 15.7899C17.4615 15.7142 17.4484 15.6369 17.4125 15.5693L16.4441 13.7609C16.6759 13.3367 16.8617 12.8888 16.9983 12.4251L18.9641 11.8418C19.0365 11.8194 19.0999 11.7745 19.145 11.7137C19.1901 11.6528 19.2146 11.5792 19.215 11.5034V9.51426C19.2184 9.44172 19.1996 9.36987 19.161 9.30835C19.1224 9.24682 19.0659 9.19858 18.9991 9.17009ZM10.5 13.7084C9.86543 13.7084 9.24514 13.5203 8.71753 13.1677C8.18992 12.8152 7.7787 12.3141 7.53587 11.7279C7.29304 11.1416 7.2295 10.4965 7.3533 9.87418C7.47709 9.25182 7.78265 8.68015 8.23135 8.23146C8.68004 7.78276 9.25171 7.4772 9.87407 7.3534C10.4964 7.22961 11.1415 7.29315 11.7278 7.53598C12.314 7.77881 12.8151 8.19003 13.1676 8.71764C13.5202 9.24524 13.7083 9.86554 13.7083 10.5001C13.7083 11.351 13.3703 12.167 12.7686 12.7687C12.1669 13.3704 11.3509 13.7084 10.5 13.7084Z"
      fill={fill}
    />
  </svg>
);

const Logout = ({ className = "", fill = "#606B80" }) => (
  <svg
    className={className}
    width="21"
    height="21"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      {/* <path fill="none" d="M0 0h24v24H0z" /> */}
      <path
        d="M5 11h8v2H5v3l-5-4 5-4v3zm-1 7h2.708a8 8 0 1 0 0-12H4A9.985 9.985 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.985 9.985 0 0 1-8-4z"
        fill={fill}
      />
    </g>
  </svg>
);

export {
  SupportAccess,
  WindowSidebar,
  User,
  NotAllowed,
  Users,
  Refresh,
  Notification,
  Close,
  Envelope,
  Bell,
  MegaPhone,
  CustomPlansIcon,
  Logout,
};
